module.exports = __webpack_public_path__ + "img/v5.e20c43ac.png";